import {
    makeAdUrl,
    makeExecutorUrl,
} from '@frontend/helpers'
import type {ChatDetailsData} from '@frontend/modules/private/chats/ChatsModuleTypes'

export interface ChatHeaderData {
    coverImage: string | null
    title: string
    sellerName: string
    itemUrl: string
}

// Получить данные для заголовка чата.
export function getChatHeaderData(chat: ChatDetailsData): ChatHeaderData {
    if (chat.ad) {
        // Объявление.
        return {
            coverImage: chat.ad.cover,
            title: chat.ad.title,
            sellerName: chat.otherUser.name,
            itemUrl: makeAdUrl(chat.ad.slugWithId, chat.ad.categorySlugWithId),
        }
    }
    // Исполнитель.
    return {
        coverImage: chat.executor!.cover,
        title: chat.executor!.title,
        sellerName: chat.otherUser.name + ': ' + chat.executor!.category,
        itemUrl: makeExecutorUrl(chat.executor!.slugWithId, chat.executor!.categorySlugWithId),
    }
}
